import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '@env/environment';
import { AppConfig } from '@shared/models/app-config.model';


@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  apiUrl = environment.apiUrl + '/app_config/';
  private config: Record<string, any> = {
    fc_contact_address_line_1: '1100 Market Street',
    fc_contact_address_line_2: 'Suite 600',
    fc_contact_city: 'Chattanooga',
    fc_contact_email: 'info@landyield.com',
    fc_contact_phone: '(423) 667-3625',
    fc_help_email: 'info@landyield.com',
    fc_help_phone: '(423) 667-3625',
    fc_contact_state: 'TN',
    fc_contact_zip: '37402',
  };
  private loaded: boolean;

  constructor(readonly http: HttpClient) {}

  load(): Observable<void> {
    return this.http.get<AppConfig[]>(this.apiUrl, { headers: new HttpHeaders().set('X-FC-Noauth', 'true') })
      .pipe(
        tap((cfg: AppConfig[]) => {
          cfg.forEach(element => (this.config[element.key] = element.value))
          this.loaded = true;
        }),
        map(() => void 0)
      );
  }

  getFloat(key: string, defaultValue: number): number {
    const value = this.getValue(key, defaultValue.toString());
    let returnValue = parseFloat(value)
    return isNaN(returnValue) ? defaultValue : returnValue;
  }

  getValue(key: string, defaultValue: string = ''): string {
    return this.config[key] ?? defaultValue;
  }

  getJSONValue(key: string, defaultValue: any) {
    let returnValue = defaultValue;
    const value = this.getValue(key, returnValue);
    try {
      returnValue = JSON.parse(value)
    } catch (e) {
      return defaultValue;
    }
    return returnValue;
  }

  getPopupDetails(key: string) {
    let popups = this.getJSONValue('popup-details', []);
    return popups.find(p => p.key === key) ?? {};
  }

  getAllAppConfig(): Observable<AppConfig[]> {
    return this.http.get<AppConfig[]>(this.apiUrl, { headers: new HttpHeaders().set('X-FC-Noauth', 'true') });
  }

  getAppConfigById(id: number): Observable<AppConfig> {
    return this.http.get<AppConfig>(`${this.apiUrl}${id}`).pipe(map((response: AppConfig) => response));
  }

  updateAppConfig(appConfig: AppConfig): Observable<AppConfig> {
    return this.http.put(`${this.apiUrl}`, appConfig).pipe(map((response: AppConfig) => response));
  }

}
